export default function KeywordsCard({ data, loading }) {
  return (
    <div className={`card bg-base-100 shadow-xl widget-card ${loading ? 'loading' : ''}`} style={{ minHeight: '192px', height: 'auto' }}>
      <div className="card-body py-3 flex flex-col justify-between" style={{ minHeight: '160px' }}>
        <h2 className="card-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6z" />
          </svg>
          Keywords
        </h2>
        
        {loading ? (
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner loading-md"></span>
          </div>
        ) : data ? (
          <div className="flex flex-wrap gap-2">
            {data.keywords?.map((keyword, index) => (
              <span key={index} className="badge badge-primary badge-lg">
                {keyword}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}